import { MRT_ColumnDef } from "material-react-table";
import { CollectionModel, PaymentModel, GroupedPaymentModel, PaymentModelDetail } from "../types-interfaces/types";
import InputSelect from "../components/input/InputSelect";

const columnsPayments: MRT_ColumnDef<PaymentModel>[] = [
  {
    accessorKey: "customerId",
    header: "RUT cliente",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "payerId",
    header: "RUT pagador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentCreationDate",
    header: "Fecha de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => cell.getValue<number>().toString().split('T')[0].split('-').reverse().join("/")
  },
  {
    accessorKey: "accrualDate",
    header: "Fecha devengo",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      return !cell.getValue()
        ? ""
        : cell.getValue<string>().split("-").reverse().join("/");
    },
  },
  {
    accessorKey: "amount",
    header: "Monto",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "right",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentConfirmDate",
    header: "Fecha recaudación",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      return cell.getValue() === ""
        ? ""
        : new Date(cell.getValue<number>())
            .toLocaleDateString()
            .replaceAll("-", "/");
    },
  },
  {
    accessorKey: "status",
    header: "Estado",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentType",
    header: "Medio de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "company",
    header: "Compañia Recaudadora",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "depositBank",
    header: "Banco recaudador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "userCreator",
    header: "Usuario Creador",
    size: 250,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "collectionId",
    header: "ID Cobranza",
    size: 250,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
];

const columnsCollection: MRT_ColumnDef<CollectionModel>[] = [
  {
    accessorKey: "customerId",
    header: "RUT cliente",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "payerId",
    header: "RUT pagador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "amount",
    header: "Monto",
    size: 150,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "right",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "accrualDate",
    header: "Fecha devengo",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "moneyType",
    header: "Money type",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "accountId",
    header: "N° cuenta",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "productType",
    header: "Producto",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "createAt",
    header: "Fecha de cobranza",
    size: 150,
    muiTableHeadCellProps: {
      align: "center",
    },
    Cell: ({ cell }) =>
      new Date(cell.getValue<number>())
        .toLocaleDateString()
        .replaceAll("-", "/"),
  },
  {
    accessorKey: "status",
    header: "Estado",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "requestId",
    header: "ID Solicitud",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "id",
    header: "ID Cobranza",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
];

const columnsPaymentsManualLink: MRT_ColumnDef<PaymentModel>[] = [
  {
    accessorKey: "payerId",
    header: "RUT pagador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "amount",
    header: "Monto",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentCreationDate",
    header: "Fecha de Pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) =>
      new Date(cell.getValue<number>())
        .toLocaleDateString()
        .replaceAll("-", "/"),
  },
  {
    accessorKey: "accrualDate",
    header: "Periodo de devengo",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentType",
    header: "Medio de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "company",
    header: "Recaudadora",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
];

const columnsCollectionManualLink: MRT_ColumnDef<CollectionModel>[] = [
  {
    accessorKey: "payerId",
    header: "RUT pagador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "amount",
    header: "Monto",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "accrualDate",
    header: "Fecha devengo",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) =>
      new Date(cell.getValue<string>()?.replace("A", "")) //TODO: validar que sucede con la A
        .toLocaleDateString()
        .replaceAll("-", "/"),
  },
  {
    accessorKey: "moneyType",
    header: "Money type",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "accountId",
    header: "N° cuenta",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "productType",
    header: "Producto",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "requestId",
    header: "ID solicitud",
    size: 250,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
];

const paymentStateUpdateColumns = (handleModal: (type: string, isOpen: boolean, payment: PaymentModel) => void) : MRT_ColumnDef<PaymentModel>[] => {
  const columns: MRT_ColumnDef<PaymentModel>[] = [
    {
      accessorKey: "customerId",
      header: "RUT cliente",
      size: 100,
      muiTableHeadCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "payerId",
      header: "RUT pagador",
      size: 100,
      muiTableHeadCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "paymentCreationDate",
      header: "Fecha Creación de pago",
      size: 100,
      muiTableHeadCellProps: {
        align: "center",
      },
      Cell: ({ cell }) =>
        new Date(cell.getValue<number>())
          .toLocaleDateString()
          .replaceAll("-", "/"),
    },
    {
      accessorKey: "amount",
      header: "Monto",
      size: 200,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "right",
      },
      Cell: ({ cell }) => {
        let currency = cell.row.original.currencyType;
        return currency === "UF"
          ? cell.getValue<number>()
          : cell.getValue<number>().toLocaleString("es-CL", {
              style: "currency",
              currency: currency ?? "CLP",
            });
      },
    },
    {
      accessorKey: "currencyType",
      header: "Moneda",
      size: 100,
      muiTableHeadCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "status",
      header: "Estado del Pago",
      size: 100,
      muiTableHeadCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "paymentType",
      header: "Medio de pago",
      size: 100,
      muiTableHeadCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "collectionAmount",
      header: "Monto Cobranza",
      size: 250,
      muiTableHeadCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        let currency = cell.row.original.currencyType;
        return currency === "UF"
          ? cell.getValue<number>()
          : cell.getValue<number>().toLocaleString("es-CL", {
              style: "currency",
              currency: currency ?? "CLP",
            });
      },
    },
    {
      accessorKey: "user",
      header: "Usuario Creador",
      size: 250,
      muiTableHeadCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "actions",
      header: "Acciones",
      size: 250,
      muiTableHeadCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        return (
          <span>
            <InputSelect
              className="select-action"
              values={[
                { name: "Selecciona acción", value: "open" },
                { name: "Anular", value: "Anular" },
                { name: "Devolver", value: "Devolver" },
                { name: "Desvincular", value: "Desvincular" },
              ]}
              onChange={(evt: any) => {
                handleModal(evt.currentTarget.value, true, cell.row.original);
              }}
            />
          </span>
        );
      },
    },
  ];

  return columns;
};

const columnsGroupedPayments: MRT_ColumnDef<GroupedPaymentModel>[] = [  
  {
    accessorKey: "paymentType",
    header: "Medio de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "companyType",
    header: "Entidad Recaudadora",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentsQuantity",
    header: "Cantidad de pagos",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "total",
    header: "Total",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "right",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },
  {
    accessorKey: "depositBank",
    header: "Banco recaudador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "depositId",
    header: "Id abono",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },  
  {
    accessorKey: "paymentDate",
    header: "Fecha de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      return !cell.getValue()
        ? ""
        : cell.getValue<string>().split("-").reverse().join("/");
    },
  },  
];

const columnsGroupedPaymentsCollection: MRT_ColumnDef<GroupedPaymentModel>[] = [  
  {
    accessorKey: "paymentType",
    header: "Medio de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "companyType",
    header: "Entidad Recaudadora",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "paymentsQuantity",
    header: "Cantidad de pagos",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "total",
    header: "Total",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "right",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },
  {
    accessorKey: "paymentDate",
    header: "Fecha de pago",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      return !cell.getValue()
        ? ""
        : cell.getValue<string>().split("-").reverse().join("/");
    },
  },  
];

const columnsGroupedPaymentsDetail: MRT_ColumnDef<PaymentModelDetail>[] = [  
  {
    accessorKey: "customerId",
    header: "RUT cliente",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "payerId",
    header: "RUT pagador",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "currencyType",
    header: "Moneda",
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "amount",
    header: "Monto",
    size: 200,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "right",
    },
    Cell: ({ cell }) => {
      let currency = cell.row.original.currencyType;
      return currency === "UF"
        ? cell.getValue<number>()
        : cell.getValue<number>().toLocaleString("es-CL", {
            style: "currency",
            currency: currency ?? "CLP",
          });
    },
  },  
]


export {
  columnsPayments,
  columnsCollection,
  columnsPaymentsManualLink,
  columnsCollectionManualLink,
  paymentStateUpdateColumns,
  columnsGroupedPayments,
  columnsGroupedPaymentsDetail,
  columnsGroupedPaymentsCollection
};